import React from 'react';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

function PalapaRingTengahDetail() {
    const stats = [
        ['1.320,15 km', 'Kabel Darat'],
        ['1.823,51 km', 'Kabel Laut'],
        ['3.143,66 km', 'Total Jaringan'],
        ['100 Gbps', 'Kapasitas'],
    ];

    return (
        <div className="py-4 lg:py-6">
            <div className="mb-7">
                <span className="text-xs font-semibold uppercase tracking-[0.24em] text-blue-600">Backbone Indonesia</span>
                <h2 className="mt-2 text-3xl font-bold tracking-tight text-slate-950 sm:text-4xl">Palapa Ring Tengah</h2>
            </div>

            <section className="overflow-hidden rounded-[30px] border border-slate-200 bg-white shadow-[0_22px_60px_rgba(15,23,42,0.08)]">
                <div className="grid lg:grid-cols-[0.92fr_1.08fr]">
                    <div className="p-6 sm:p-8 lg:p-10">
                        <p className="text-base leading-8 text-slate-600">
                            <strong className="text-slate-950">Palapa Ring</strong> merupakan proyek infrastruktur telekomunikasi yang bertujuan membangun jaringan serat optik di seluruh wilayah Indonesia, termasuk daerah-daerah terpencil. Proyek ini dikenal sebagai tulang punggung atau backbone internet Indonesia, menghubungkan wilayah yang sebelumnya kurang memiliki akses telekomunikasi dan digital. Palapa Ring terdiri dari Paket Barat, Paket Tengah, dan Paket Timur.
                        </p>
                        <p className="mt-5 text-base leading-8 text-slate-600">
                            Salah satu bagian dari proyek ini adalah <strong className="text-slate-950">Palapa Ring Paket Tengah</strong>, yang bertujuan meningkatkan konektivitas di wilayah Kalimantan, Sulawesi, dan Kepulauan Maluku Utara.
                        </p>
                    </div>

                    <div className="flex items-center bg-[#071426] p-3 sm:p-5 lg:p-6">
                        <div className="w-full overflow-hidden rounded-[22px] border border-white/10 bg-[#101a2d] p-2 sm:p-3">
                            <Zoom>
                                <img
                                    src="/assets-web/profil_palapa_ring.png"
                                    alt="Peta jaringan Palapa Ring Tengah"
                                    loading="lazy"
                                    decoding="async"
                                    className="h-auto w-full cursor-zoom-in object-contain"
                                    style={{ filter: 'brightness(1.16) contrast(1.08)' }}
                                />
                            </Zoom>
                        </div>
                    </div>
                </div>
            </section>

            <div className="mt-5 grid grid-cols-2 gap-3 lg:grid-cols-4">
                {stats.map(([value, label]) => (
                    <article key={label} className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                        <div className="text-xl font-bold text-[#005da2] sm:text-2xl">{value}</div>
                        <div className="mt-1 text-xs font-medium text-slate-500 sm:text-sm">{label}</div>
                    </article>
                ))}
            </div>

            <section className="mt-5 rounded-[28px] border border-slate-200 bg-white p-6 shadow-[0_18px_45px_rgba(15,23,42,0.06)] sm:p-8 lg:p-10">
                <h3 className="text-2xl font-bold text-slate-950">Tentang Palapa Ring Tengah</h3>
                <div className="mt-5 grid gap-5 lg:grid-cols-2">
                    <p className="text-sm leading-7 text-slate-600 sm:text-base">
                        Palapa Ring Tengah merupakan bagian dari Proyek KPBU (Kerjasama Pemerintah dengan Badan Usaha) dengan model kerjasama <strong className="text-slate-950">Bangun Milik Guna Serah (Build Own Operate Transfer/BOOT)</strong>. Proyek ini mencakup pembangunan jaringan serat optik di wilayah Kalimantan, Sulawesi, dan Kepulauan Maluku Utara, dengan cakupan 17 kabupaten di wilayah tersebut.
                    </p>
                    <p className="text-sm leading-7 text-slate-600 sm:text-base">
                        Proyek ini menggunakan teknologi DWDM terkini dan mampu menyediakan kapasitas hingga 100 Gbps pada setiap proyeknya. Palapa Ring Tengah telah beroperasi sejak 21 Desember 2018 dan menyediakan akses telekomunikasi di 17 kota layanan dan 10 kota interkoneksi.
                    </p>
                </div>
            </section>
        </div>
    );
}

export default PalapaRingTengahDetail;
